import * as React from "react";
import {resourcesHelper} from "@ferry/portal-core";
import {ImgTileLink} from "../../../../../components/ImgTileLink";

interface IMigratedRenewalTilesProps {
    migratedRenewalStatusAccepted: boolean;
    interaction: any;
    onCancelClick?: () => void;
}

export const MigratedRenewalTiles: React.FC<IMigratedRenewalTilesProps> = ({
                                                                               migratedRenewalStatusAccepted,
                                                                               interaction,
                                                                               onCancelClick
                                                                           }) => {
    const isAcceptedMigratedRenewal = migratedRenewalStatusAccepted;

    return (
        <div className="link-grid">
            <div className="d-flex flex-wrap">
                {/* Your car tile */}
                <div className="flexItem car">
                    <ImgTileLink
                        id="carTile"
                        src={`/${resourcesHelper.THEME_PATH}/img/car-icon-panel.svg`}
                        alt="Car icon"
                        to={`/journey/show/product/AnnualMotorInsurance/process/nb/summary/${interaction._id}`}
                        hasInfoButton={false}
                    >
                        Your renewal quote
                    </ImgTileLink>
                </div>

                {/* Payment tile */}
                {isAcceptedMigratedRenewal && (
                    <div className="flexItem payment">
                        <ImgTileLink
                            id="paymentTile"
                            src={`/${resourcesHelper.THEME_PATH}/img/payment-wallet.svg`}
                            alt="Payment icon"
                            to={`/dashboard/migratedRenewal/paymentDetails`}
                            hasInfoButton={true}
                            infoModalTitle="Payment"
                            infoModalBulletPoints={[
                                "Change your payment day",
                                "Edit your monthly payment details",
                                "Change your payment card",
                                "Pay off your balance",
                                "View payment history"
                            ]}
                        >
                            Payment
                        </ImgTileLink>
                    </div>
                )}

                {/* Documents tile */}
                <div className="flexItem documents">
                    <ImgTileLink
                        id="policyDocumentsTile"
                        src={`/${resourcesHelper.THEME_PATH}/img/documents.svg`}
                        alt="Documents icon"
                        to={`/dashboard/migratedRenewalDocuments`}
                        hasInfoButton={true}
                        infoModalTitle="Documents"
                        infoModalBulletPoints={[
                            "View your policy documents",
                            "View your old policy documents",
                            "Request documents to be sent by post"
                        ]}
                    >
                        Documents
                    </ImgTileLink>
                </div>

                {/* Account details tile */}
                <div className="flexItem account-details">
                    <ImgTileLink
                        src={`/${resourcesHelper.THEME_PATH}/img/account-details.svg`}
                        alt="Account details icon"
                        to={`/dashboard/migratedRenewal/annualMotorAccount`}
                        hasInfoButton={true}
                        infoModalTitle="Account details"
                        infoModalBulletPoints={[
                            "View and amend account holder details (e.g. email, phone number, address, password)",
                            "Opt in to auto-renew your policy"
                        ]}
                    >
                        Account details
                    </ImgTileLink>
                </div>

                {isAcceptedMigratedRenewal && (
                    <div className="flexItem cancel-policy">
                        <div
                            className="img-tile-link cursor-pointer"
                            onClick={onCancelClick}
                        >
                            <img
                                src={`/${resourcesHelper.THEME_PATH}/img/cancel-policy.svg`}
                                alt="Cancel renewal"
                            />
                            <div className="link-name">
                                Cancel renewal
                                <div className="info-button"></div>
                            </div>
                        </div>
                    </div>
                )}

                <div className="flexItem help">
                    <ImgTileLink
                        src={`/${resourcesHelper.THEME_PATH}/img/help.svg`}
                        alt="Help icon"
                        to={`/dashboard/migratedRenewal/help`}
                        hasInfoButton={true}
                        infoModalTitle="Help"
                        infoModalBulletPoints={["Read FAQs about your cover, account, payment, breakdown, renewal, claims, NCD..."]}
                    >
                        Help
                    </ImgTileLink>
                </div>
            </div>
        </div>
    );
};
